export enum ROUTES {
  ROOT = '/',
  ADMIN = '/admin',
  LOGIN = '/login',
  REGISTRATION = '/registration',
  USER = '/user',
  ORDER = '/admin/order'
}

export enum ROLES {
  USER = 'user',
  ADMIN = 'rimon'
}

export enum LOCATIONS {
  TA = 'TA',
  PH = 'PH'
}

export enum UNIT_TYPE {
  UNIT = 'unit',
  KG = 'Kg'
}

export enum ORDER_STATUS {
  OPEN = 'open',
  COMPLETION = 'completion',
  SHOPPING = 'shopping',
  PAYING = 'paying',
  CLOSED = 'closed'
}